import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import Commissions from '../components/Commissions.vue';
import PrivacyPolicy from '../components/PrivacyPolicy.vue';
import Contact from '../components/Contact.vue';
import Examples from '../components/Examples.vue';
import Shop from '../components/Shop.vue';

export const router = new VueRouter({
  mode: 'history',
  routes: [
      {path: '/', component: Home},
      {path: '/commissions', component: Commissions},
      {path: '/privacypolicy', component: PrivacyPolicy},
      {path: '/contact', component: Contact},
      {path: '/examples', component: Examples},
      {path: '/shop', component: Shop},
  ],
});
